<template>
  <div class="modal fade" id="allServiceMinutesModal">
    <div class="modal-dialog modal-lg" role="document">
      <div v-if="selectedStudent != null" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{selectedStudent.get("name")}}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row mt-2 mb-2">
              <div class="col mt-auto">
                <label for="'allServiceMinutesFrom'">From</label>
                <input
                  type="date"
                  class="form-control"
                  id="allServiceMinutesFrom"
                  v-model="startDate"
                  required
                />
              </div>
              <div class="col mt-auto">
                <label for="allServiceMinutesEnd">To</label>
                <input
                  type="date"
                  class="form-control"
                  id="allServiceMinutesEnd"
                  v-model="endDate"
                  required
                />
              </div>
              <div class="col-auto">
                <button class="btn btn-primary btn-block mb-2" v-on:click="print">Print</button>
                <button class="btn btn-primary mt-auto" v-on:click="loadData">Apply</button>
              </div>
          </div>
          <div class="row mt-2 mb-2">
            <div class="col" />
            <div class="col-auto mr-4">
              <input type="checkbox" id="hideNotesCheckBox" v-model="hideNotes">
              <label class="ml-2" for="hideNotesCheckBox">Hide notes</label>
            </div>
            <div class="col-auto">
              <input type="checkbox" id="hideRecorderCheckBox" v-model="hideRecorder">
              <label class="ml-2" for="hideRecorderCheckBox">Hide Recorder</label>
            </div>
            <div class="col" />
          </div>
          <div id="printThis" class="p-2" style="width: 100%">
            <div class="row">
              <div class="col-auto">
                <h3>
                  {{selectedStudent.get("name")}}
                </h3>
              </div>
              <div class="col" />
              <div class="col-auto">
                <h3>{{ appliedStartDate }} - {{ appliedEndDate }}</h3>
              </div>
            </div>
            <div v-for="(minutes, serviceId) in groups" :key="serviceId">
              <div class="row mt-4">
                <div class="col-auto pl-1"><h4 class="mb-0">{{services.find(s => s.id == serviceId).get("name")}}</h4></div>
                <div class="col" />
                <div class="col-auto"><h4 class="mb-0">Total Minutes: {{sum(minutes, "minutes")}}</h4></div>
              </div>
              <div style="width: 100%; background-color: gray; height: 1px; margin-bottom: 0.5rem;"/>
              <p v-if="minutes == null || minutes.length == 0">{{ selectedStudent.get("name") }} does not have any service minutes recorded this time period.</p>
              <div v-else class="row mt-2" v-for="singleMinutes in minutes" :key="singleMinutes.id">
                <div class="col text-left">
                  <p class="mb-0"><b>{{singleMinutes.get("date").toUTCString().split(' ')[2]}} {{singleMinutes.get("date").toUTCString().split(' ')[1]}}, {{singleMinutes.get("date").toUTCString().split(' ')[3]}}</b><i>{{ hideRecorder ? "" : " - " + singleMinutes.get("userName") }}</i>{{ hideNotes ? "" : " - " + singleMinutes.get("services") }}</p>
                </div>
                <div class="col-auto">
                  <h4 class="d-inline-block mb-0">
                    {{singleMinutes.get("minutes")}}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Parse from "parse";

export default {
  name: "AllServiceMinutesModal",
  props: {
    SelectedStudent: Object,
    Services: Array
  },
  data() {
    return {
      selectedStudent: null,
      startDate: null,
      endDate: null,
      appliedStartDate: "",
      appliedEndDate: "",
      hideNotes: false,
      hideRecorder: false,
      serviceMinutes: [],
      services: []
    };
  },
  async mounted() {
    $("#allServiceMinutesModal").on("shown.bs.modal", this.setupService);
    $("#allServiceMinutesModal").on("hidden.bs.modal", this.clearService);
  },
  computed:{
    groups(){
      return this.groupBy(this.serviceMinutes, 'receivedService')
    }
  },
  methods: {
    async loadData() {
      var student = this.selectedStudent;
      this.selectedStudent = null;
      if(student != null){
        this.$store.commit("updateLoading", true);
        let query = new Parse.Query("ServiceMinutes")
        query.equalTo("studentId", student.id)
        //query.equalTo("receivedService", this.studentService["service"])
        var startDateDate = new Date(this.startDate)
        var endDateDate = new Date(this.endDate)
        this.appliedStartDate = startDateDate.toUTCString().split(' ')[2] + " " + startDateDate.toUTCString().split(' ')[1] + ", " + startDateDate.toUTCString().split(' ')[3]
        this.appliedEndDate = endDateDate.toUTCString().split(' ')[2] + " " + endDateDate.toUTCString().split(' ')[1] + ", " + endDateDate.toUTCString().split(' ')[3]
        query.descending("date")
        query.greaterThanOrEqualTo("date", startDateDate)
        query.lessThanOrEqualTo("date", endDateDate)
        query.containedIn("receivedService", this.services.map(s => s.id))
        query.limit(1000)
        this.serviceMinutes = await query.find()
        this.$store.commit("updateLoading", false);
      }
      this.selectedStudent = student
    },
    clearService() {
      this.selectedStudent = null
    },
    setupService() {
      if(this.SelectedStudent != null){
        this.selectedStudent = this.SelectedStudent
      }
      if(this.Services != null){
        this.services = this.Services
      }
      var date = new Date(), y = date.getFullYear(), m = date.getMonth(), d = date.getDate()
      this.endDate = this.$dateToYYYYMMDD(new Date(y, m, d, 0, 0, 0, 0))
      this.startDate = this.$dateToYYYYMMDD(new Date(y, m - 1, d, 23, 59,59))
      console.log("let's  load the data")
      this.loadData()
    },
    sum(items, prop) {
      if (items == null) {
        console.log("items was null!")
        return 0;
      }
      var sum = items.reduce((acc, item) => acc + item.get(prop), 0);
      return sum;
    },
    groupBy(array, key){
      const result = {}
      this.selectedStudent.get("services").forEach(service => {
        result[service["service"]] = []
      })
      array.forEach(item => {
        if (!result[item.get(key)]){
          result[item.get(key)] = []
        }
        result[item.get(key)].push(item)
      })
      return result
    },

    print(){
      const modal = document.getElementById("printThis")
      var domClone = modal.cloneNode(true);
    
      var $printSection = document.getElementById("printSection");
      
      if (!$printSection) {
          $printSection = document.createElement("div");
          $printSection.id = "printSection";
          document.body.appendChild($printSection);
      }
      
      $printSection.innerHTML = "";
      $printSection.appendChild(domClone);
      window.print();
    }
  }
}
</script>
<style>
@media screen {
  #printSection {
      display: none;
  }
}

@media print {
  body * {
    visibility:hidden;
  }
  #printSection, #printSection * {
    visibility:visible;
  }
  #printSection {
    position:absolute;
    left:0;
    top:0;
    width:100%
  }
}
</style>